import React from "react";
import GraphSubscriptionTableHeader from "./components/GraphSubscriptionTableHeader";
import GraphSubscriptionTableRow from "./components/GraphSubscriptionTableRow";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable"
import { useGraphSubscriptions } from "./hooks/GraphSubscriptionListContext";

const GraphSubscriptionsTable = () => {
    const {
        clear: refreshTable,
        data,
        error,
        isLoading,
        isNextPageLoading,
        isNewRecords,
        isRowLoaded,
        loadMore,
        newRecordsSinceCache,
        totalCount
    } = useGraphSubscriptions();

    const isNewRecordsDisplayed = isNewRecords && !isLoading && !isNextPageLoading;
    return (
        <VirtualTable
            enableScrollTracking={false}
            row={GraphSubscriptionTableRow}
            header={(
                <thead>
                <tr>
                    <GraphSubscriptionTableHeader property="user">User</GraphSubscriptionTableHeader>
                    <GraphSubscriptionTableHeader property="typeDescription">Resource</GraphSubscriptionTableHeader>
                    <GraphSubscriptionTableHeader property="changeType">Type</GraphSubscriptionTableHeader>
                    <GraphSubscriptionTableHeader property="notificationUrl">URL</GraphSubscriptionTableHeader>
                    <GraphSubscriptionTableHeader property="expirationDate">Expires</GraphSubscriptionTableHeader>
                    <GraphSubscriptionTableHeader property="createdDate">Created</GraphSubscriptionTableHeader>
                    <GraphSubscriptionTableHeader property="createdBy">Created By</GraphSubscriptionTableHeader>
                    <th className="sticky-header">&nbsp;</th>
                </tr>
                </thead>
            )}
            footer={
                <TableRecordCountDisplayFooter
                    totalCount={totalCount}
                    isNewRecordsDisplayed={isNewRecordsDisplayed}
                    newRecordsSinceCache={newRecordsSinceCache}
                    reload={refreshTable}
                />
            }
            error={error}
            isLoading={isNextPageLoading}
            isItemLoaded={isRowLoaded}
            loadMoreItems={loadMore}
            itemSize={30}
            itemCount={totalCount}
            itemData={data}
        />
    );
};

export { useGraphSubscriptions };
export { openCreateSubscriptionModal } from "./components/CreateSubscriptionModal";
export { GraphSubscriptionListProvider } from "./hooks/GraphSubscriptionListContext";
export default GraphSubscriptionsTable;